var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('span',{staticClass:"link",on:{"click":_vm.openModalAction}},[_c('i',{staticClass:"fal fa-lock-alt"}),_vm._v(" 登録を解除")])])}
var staticRenderFns = []

export { render, staticRenderFns }